var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAvatarOutlined(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_688_904)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.1666 30.6667H30.6666V30.1667V28.3334C30.6666 28.0098 30.4813 27.7361 30.305 27.54C30.1147 27.3284 29.8549 27.1191 29.5534 26.9174C28.9475 26.512 28.1055 26.0925 27.1225 25.7137C25.156 24.9559 22.5529 24.3334 20 24.3334C17.447 24.3334 14.8439 24.9559 12.8775 25.7137C11.8944 26.0925 11.0524 26.512 10.4465 26.9174C10.145 27.1191 9.8852 27.3284 9.69494 27.54C9.51865 27.7361 9.33329 28.0098 9.33329 28.3334V30.1667V30.6667H9.83329H30.1666ZM24 13.3334C24 11.1239 22.2094 9.33335 20 9.33335C17.7905 9.33335 16 11.1239 16 13.3334C16 15.5428 17.7905 17.3334 20 17.3334C22.2094 17.3334 24 15.5428 24 13.3334ZM13.8333 13.3334C13.8333 9.92616 16.5928 7.16669 20 7.16669C23.4072 7.16669 26.1666 9.92616 26.1666 13.3334C26.1666 16.7326 23.4067 19.5 20 19.5C16.5932 19.5 13.8333 16.7326 13.8333 13.3334ZM7.16663 28.3334C7.16663 27.4065 7.62649 26.5585 8.46442 25.7853C9.30581 25.009 10.4949 24.3421 11.8534 23.7986C14.5713 22.7113 17.8414 22.1667 20 22.1667C22.1585 22.1667 25.4287 22.7113 28.1465 23.7986C29.5051 24.3421 30.6941 25.009 31.5355 25.7853C32.3734 26.5585 32.8333 27.4065 32.8333 28.3334V32.8334H7.16663V28.3334Z",
    fill: "black",
    stroke: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_688_904"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAvatarOutlined);
export default __webpack_public_path__ + "static/media/icon-avatar-outlined.5e7afffd93df31bcd55c492e7d4f422a.svg";
export { ForwardRef as ReactComponent };